import React from 'react';
import styled from 'styled-components';

import Page from 'components/Page';


const FAQTemplate = ({ page: { acf: { faqs = [] } } }) => {
    return (
        <Page>
            <Inner>
                <Header>
                    <Title className="h5">FREQUENTLY ASKED QUESTIONS</Title>
                </Header>
                <Content>
                    <List>
                        {faqs.map(({ question, answer }, index) => (
                            <Item key={index}>
                                <Question className="h6">{question}</Question>
                                {answer && <Answer dangerouslySetInnerHTML={{ __html: answer }} />}
                            </Item>
                        ))}
                    </List>
                </Content>
            </Inner>
        </Page>
    );
};


export default FAQTemplate;


const Inner = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
`;

const Content = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    padding: 5rem 30rem;
`;

const Header = styled.div`
    flex: 0 0 auto;
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
    width: 21rem;
    padding: 3rem;
    background-color: ${props => props.theme.secondary_color_mid};
`;

const Title = styled.div`
    writing-mode: vertical-rl;
    text-orientation: mixed;
    transform: rotate(-180deg);
    color: ${props => props.theme.primary_color};
`;

const List = styled.div`
    width: 100%;
    column-count: 2;
    column-gap: 5rem;
`;

const Item = styled.div`
    break-inside: avoid;
    padding-bottom: 2.5rem;
    margin-bottom: 2.5rem;
    border-bottom: 0.1rem solid ${props => props.theme.accent_color};
`;

const Question = styled.div`
    color: ${props => props.theme.primary_color};
    margin-bottom: 1rem;
`;

const Answer = styled.div`
    color: ${props => props.theme.primary_color_mid};

    &:has(ul) {
        column-count: 2;
    }

    p {
        margin-bottom: .5rem;
    }
    p:last-child {
        margin-bottom: 0;
    }
    
    p:has(+ ul) {
        margin-bottom: 0;
    }
    
    ul {
        break-inside: avoid;
        margin: 0 0 .5rem 0;
    }
`;
